<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12" style="text-align: center;">
                Copyright @ {{year}} Cerebrumx Labs.
            </div>
        </div>
    </div>
</footer>